const NewRelicUtils = {
    // Sets a custom attribute on the New Relic agent.
    setCustomAttribute(name, value) {
        if (!name || !value) {
            return;
        }

        window.newrelic?.setCustomAttribute(name, value);
    },
};

export default NewRelicUtils;
